// @ts-check

import * as _ from 'lodash-es'
import { v4 as createUuid } from 'uuid'
import { postNativeMessage } from './mobile'

window.URL = window.URL || window.webkitURL

const base64ToArrayBuffer = (base64Str) => {
  const binaryString = window.atob(base64Str)
  const binaryLen = binaryString.length
  const bytes = new Uint8Array(binaryLen)
  for (let i = 0; i < binaryLen; i += 1) {
    const ascii = binaryString.charCodeAt(i)
    bytes[i] = ascii
  }
  return bytes
}

export const createRandomUuid = () => createUuid()

export const downloadFile = (
  data,
  name,
  type = 'image/jpeg',
  isMobileWrapperUser = false
) => {
  if (isMobileWrapperUser) {
    const message = JSON.stringify({
      type: 'ukkopro_file_action',
      message: {
        fileData: data,
        name,
        action: 'download',
        type
      }
    })
    postNativeMessage(message)
  } else {
    const byte = base64ToArrayBuffer(data)
    const blob = new Blob([byte], { type })
    window.open(URL.createObjectURL(blob))
  }
}

export const compileBase64String = (data, type = 'image/jpeg') => {
  type = type === 'pdf' ? 'application/pdf' : type
  return `data:${type};base64,${data}`
}

/**
 * Converts the given data URI to a binary representation.
 * @param {string} dataURI
 * @returns {Uint8Array}
 */
export const convertDataURIToBinary = (dataURI) => {
  const BASE64_MARKER = ';base64,'
  const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length
  const base64 = dataURI.substring(base64Index)
  const raw = window.atob(base64)
  const rawLength = raw.length
  const array = new Uint8Array(new ArrayBuffer(rawLength))

  for (let charIndex = 0; charIndex < rawLength; charIndex += 1) {
    array[charIndex] = raw.charCodeAt(charIndex)
  }
  return array
}

/**
 * @template T
 * @param {T[]} array
 * @param {(item: T, index: number, items: T[]) => Promise} callback
 */
export async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}

/**
 * When using this function instead of window.open
 * it catches if the browser blocks opening a new window
 * @param {string} url
 * @param {string} target
 * @returns
 */
export async function openNewWindow(url, target = '_blank') {
  const windowOpen = window.open(url, target)
  // All browsers except Chrome
  if (!windowOpen) {
    return false
  }
  // For Chrome
  windowOpen.onload = function () {
    setTimeout(function () {
      if (windowOpen.screenX === 0) {
        return false
      }
    }, 0)
  }

  return true
}

/**
 * @param {Object} features
 * @param {string} name
 * @returns
 */
export function featureEnabled(features, name) {
  if (!_.has(features, name)) {
    return false
  }
  return features[name].enabled
}

export function featureAvailable(features, name) {
  if (!_.has(features, name)) {
    return false
  }
  return features[name].available
}

export const functions = {
  createRandomUuid
}
